/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Event_Tier_LocalInputs */



/**
* | output |
* | --- |
* | "Local" |
*
* @param {Meta_Event_Tier_LocalInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_event_tier_local = /** @type {((inputs?: Meta_Event_Tier_LocalInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Event_Tier_LocalInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lokal")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Local")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("本地")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("地區")
	if (locale === "ko") return /** @type {LocalizedString} */ ("지역")
	return /** @type {LocalizedString} */ ("Local")
});